import styled from 'styled-components'

export const Div= styled.div`
height: 100vh;
margin:auto;
width: 411px;
border-radius: 10px;
background :#EAF1F2;


`
